import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as body from './body'
import * as footer from './footer'
import { Store } from './store'

/**
 * Modal used to deploy Quiver resources
 */
@ngCore.Component({
  imports: [
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    ds.notice.Component,
    body.Component,
    footer.Component,
  ],
  selector: 'atn-quiver-deployment-modal',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link ents.core.display.Style} */
  public readonly DisplayStyle = ents.core.display.Style
}
